import { z } from 'zod';

export const delaisReglementairesSchema = z.object({
  typeMarcherId: z.number().min(1, 'Le type de marché est requis'),
  modePassationId: z.number().min(1, 'Le mode de passation est requis'),
  delaiPublicationLancement: z.number().min(0, 'Le délai de publication lancement doit être positif'),
  delaiLancementAttribution: z.number().min(0, 'Le délai lancement attribution doit être positif'),
  delaiAttributionDemarrage: z.number().min(0, 'Le délai attribution démarrage doit être positif'),
});
